/**
 * @name ExternalForce.js
 * @description 外力を追加する
 */
import * as THREE from "three";
import mouse_vert from "./shader/mouse.vert";
import externalForce_frag from "./shader/externalForce.frag";
import Mouse from "./modules/Mouse";

class ExternalForce {
    constructor(stage, props) {
        this.renderer = stage.renderer;

        this.scene = new THREE.Scene();
        this.camera = new THREE.Camera();

        this.props = props;

        this.__init();
    }

    /**
     * @name __init
     */
    __init() {
        this.__createMouse();
    }

    /**
     * @name __createMouse
     */
    __createMouse() {
        const geo = new THREE.PlaneGeometry(1, 1);
        const mat = new THREE.RawShaderMaterial({
            vertexShader: mouse_vert,
            fragmentShader: externalForce_frag,
            blending: THREE.AdditiveBlending,
            uniforms: {
                px: {
                    value: this.props.cellScale
                },
                force: {
                    value: new THREE.Vector2(0.0, 0.0)
                },
                center: {
                    value: new THREE.Vector2(0.0, 0.0)
                },
                scale: {
                    value: new THREE.Vector2(this.props.cursorSize, this.props.cursorSize)
                }
            },
        });
        this.mouse = new THREE.Mesh(geo, mat);
        this.scene.add(this.mouse);
    }

    /**
     * @name __raf
     * @param {Object} props
     */
    __raf(props) {
        const forceX = Mouse.diff.x / 2 * props.mouseForce;
        const forceY = Mouse.diff.y / 2 * props.mouseForce;

        const cursorSizeX = props.cursorSize * props.cellScale.x;
        const cursorSizeY = props.cursorSize * props.cellScale.y;

        const centerX = Math.min(Math.max(Mouse.coords.x, -1 + cursorSizeX + props.cellScale.x * 2), 1 - cursorSizeX - props.cellScale.x * 2);
        const centerY = Math.min(Math.max(Mouse.coords.y, -1 + cursorSizeY + props.cellScale.y * 2), 1 - cursorSizeY - props.cellScale.y * 2);

        const uniforms = this.mouse.material.uniforms;

        uniforms.force.value.set(forceX, forceY);
        uniforms.center.value.set(centerX, centerY);
        uniforms.scale.value.set(props.cursorSize, props.cursorSize);

        this.renderer.setRenderTarget(this.props.dst);
        this.renderer.render(this.scene, this.camera);
        this.renderer.setRenderTarget(null);
    }
}

export default ExternalForce;